module.exports = __webpack_public_path__ + "7065d05ffe126050da947cb1ccf44afb.gif";


//////////////////
// WEBPACK FOOTER
// ../assets/screenshots/tesseract/Spinning.gif
// module id = 547
// module chunks = 0